import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { styled, Grid, useMediaQuery } from '@mui/material';
import React from 'react';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { sendTextCallback } from '../../utils/textMessage.js';
import BrandclubPhoneInput from '../components/BrandclubPhoneInput/index.js';
import { GenericContainer } from '../components/GenericContainer.js';

var _a, _b, _c, _d;
var BrandclubGetAppContainer = styled(GenericContainer)((_a = {
        background: brandclub_colors.lightGreenLogo9,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: WIDGET_SPACE,
        paddingBottom: WIDGET_SPACE,
        paddingLeft: '5%',
        paddingRight: '5%',
        boxSizing: 'border-box'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        background: brandclub_colors.lightGreenLogo2,
        padding: "".concat(WIDGET_SPACE, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        background: brandclub_colors.lightGreenLogo2,
        padding: "".concat(WIDGET_SPACE, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var OverviewContent = styled(Grid)((_b = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        color: brandclub_colors.mainSeriesColor,
        width: '100%',
        position: 'relative',
        justifyContent: 'space-between',
        flexDirection: 'row'
    },
    // gap: '0px',
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        flexDirection: 'column',
        gap: '40px',
    },
    _b));
var InfoContainer = styled(Grid)((_c = {
        width: 460,
        maxWidth: 460,
        minWidth: 460
    },
    _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        maxWidth: 400,
        width: '100%',
        minWidth: 'auto',
    },
    _c['.title'] = (_d = {
            fontSize: 80,
            fontWeight: 700,
            lineHeight: 1.2
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 26,
            textAlign: 'center',
            padding: '0 20px',
        },
        _d),
    _c));
var ImageContainer = styled(Grid)({
    maxWidth: 740,
    img: {
        width: '100%',
    },
});
var BrandclubGetApp = function (_a) {
    var trackingParams = _a.trackingParams, analyticsTrack = _a.analyticsTrack, mainEntity = _a.mainEntity, brandEntity = _a.brandEntity, axios = _a.axios, userProfile = _a.userProfile;
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    return (React.createElement(BrandclubGetAppContainer, null,
        React.createElement(OverviewContent, { container: true, wrap: "nowrap", alignItems: 'center' },
            React.createElement(InfoContainer, { flex: 1 },
                React.createElement("div", { className: "title" }, "Get the Brandclub app"),
                React.createElement(Grid, { container: true, flexDirection: 'row', wrap: "nowrap", gap: '15px', justifyContent: desktopView ? 'flex-start' : 'center', marginTop: desktopView ? '50px' : '30px' },
                    React.createElement(BrandclubPhoneInput, { userProfile: userProfile, handleSendText: function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, sendTextCallback(phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK)];
                            });
                        }); } }))),
            React.createElement(ImageContainer, { flex: 1 },
                React.createElement("img", { loading: "lazy", src: "https://media.brandclub.com/brand_custom/".concat(brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id, "/getAppBot.png"), alt: "" })))));
};

export { BrandclubGetApp };
//# sourceMappingURL=index.js.map
